module.exports = __webpack_public_path__ + "static/img/img-indexnews2.79a75ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-indexnews2.png
// module id = 01Um
// module chunks = 0